import { Paper, Typography } from '@mui/material';
import { BenefitButton } from 'probonio-shared-ui/component/button';
import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import NavigationButton from '../../component/button/NavigationButton';
import { BenefitListItemProps } from '../../extension/interface/benefit-list-item.extension.interface';

export const BenefitItemButton: React.FC<BenefitListItemProps> = ({
  icon,
  title,
  titleKey,
  navigateTo,
  picture,
  benefitProgress,
  descriptionKey,
  descriptionValues,
  badgeValue,
  badgeValueKey,
}) => {
  const navigate = useNavigate();

  const handleNavigate = useCallback(() => {
    navigate(navigateTo);
  }, [navigate, navigateTo]);

  const Icon = icon;

  return (
    <BenefitButton
      title={title}
      titleKey={titleKey}
      onClick={handleNavigate}
      icon={Icon}
      picture={picture}
      benefitProgress={benefitProgress}
      descriptionKey={descriptionKey}
      descriptionValues={descriptionValues}
      badgeValue={badgeValue}
      badgeValueKey={badgeValueKey}
    />
  );
};

export const BenefitItemCard: React.FC<React.PropsWithChildren<BenefitListItemProps>> = ({
  icon,
  titleKey,
  navigateTo,
  picture,
  benefitProgress,
  descriptionKey,
  descriptionValues,
  children,
}) => {
  const navigate = useNavigate();

  const handleNavigate = useCallback(() => {
    navigate(navigateTo);
  }, [navigate, navigateTo]);

  const Icon = icon;
  return (
    <Paper sx={{ backgroundImage: 'none' }}>
      <BenefitButton
        titleKey={titleKey}
        onClick={handleNavigate}
        icon={Icon}
        picture={picture}
        benefitProgress={benefitProgress}
        descriptionKey={descriptionKey}
        descriptionValues={descriptionValues}
        sx={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
      />
      {children}
    </Paper>
  );
};

export const BenefitCardNavButton: React.FC<BenefitListItemProps> = ({
  icon,
  title,
  titleKey,
  navigateTo,
  descriptionKey,
  descriptionValues,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation('benefitModule');
  const titleText = title || t(titleKey);

  const handleNavigate = useCallback(() => {
    navigate(navigateTo);
  }, [navigate, navigateTo]);

  const Icon = icon;

  return (
    <NavigationButton iconLeft={<Icon />} onClick={handleNavigate} data-test-id={titleText}>
      <Typography variant="h3" color="text.primary">
        {titleText}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        <Trans i18nKey={descriptionKey} values={descriptionValues}>
          <Typography component="span" variant="inherit" fontWeight={700} color="success.main" />
          <Typography component="span" variant="inherit" fontWeight={700} />
        </Trans>
      </Typography>
    </NavigationButton>
  );
};
